import { InteractionStatus } from "@azure/msal-browser";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import { AppBar, Toolbar, Typography, Button, Box } from "@mui/material";
import { useEffect } from "react";

const loginRequest = { scopes: ["User.Read"] };

const Header = () => {
  const { instance, accounts, inProgress } = useMsal();

  const handleLogin = async () => await instance.loginRedirect(loginRequest);
  const handleLogout = async () => await instance.logout();

  useEffect(() => {
    (async () => {
      if (inProgress === InteractionStatus.None && !accounts[0]) {
        await instance.loginRedirect(loginRequest);
      }
    })();
  }, [accounts, instance, inProgress]);

  return (
    <AppBar position="static" sx={{ mb: 3 }}>
      <Toolbar>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          JSON Compare{" "}
          <span style={{ fontFamily: "EMPrintLight" }}>
            | Enabling Services
          </span>
        </Typography>
        <Box>

        <UnauthenticatedTemplate>
            <Button
              color="inherit"
              onClick={async () => {
                await handleLogin();
              }}
            >
              Login
            </Button>
        </UnauthenticatedTemplate>
        <AuthenticatedTemplate>
            <Button
              color="inherit"
              onClick={async () => {
                await handleLogout();
              }}
            >
              <b>
                {accounts[0]?.name ?? accounts[0]?.username ?? "Unauthenticated"}
              </b>
              {" | Logout"}
            </Button>
        </AuthenticatedTemplate>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
